module.exports = __webpack_public_path__ + "img/B5.ab2f6da0.svg";